import { FormErrorMessage } from "@chakra-ui/react";
import { FormState } from "react-hook-form";

export const FormStateErrorMessage = ({
  formState,
  field,
}: {
  formState: FormState<any>;
  field: string;
}) => {
  if (!formState.errors[field]) return null;
  return (
    <FormErrorMessage>
      {formState.errors[field]?.message as string}
    </FormErrorMessage>
  );
};
